const albums = [
    {
        "id": 1,
        "album_name": "new album",
        "album_usr": 1,
        "created_on": "2022-09-22 06:49:58",
        "updated_on": "2022-09-22 06:49:58",
        "status": "active",
        "albumLength": 0
    },
    {
        "id": 10,
        "album_name": "Beach",
        "album_usr": 1,
        "created_on": "2022-09-24 06:23:58",
        "updated_on": "2022-09-27 10:13:13",
        "status": "active",
        "albumLength": 0
    },
    // {
    //     "id": 11,
    //     "album_name": "Dishes",
    //     "album_usr": 1,
    //     "created_on": "2022-09-24 06:24:42",
    //     "updated_on": "2022-09-24 06:24:42",
    //     "status": "active",
    //     "albumLength": 0
    // },
    // {
    //     "id": 12,
    //     "album_name": "Fruit",
    //     "album_usr": 1,
    //     "created_on": "2022-09-24 06:32:13",
    //     "updated_on": "2022-09-24 06:32:13",
    //     "status": "active",
    //     "albumLength": 0
    // },
    // {
    //     "id": 13,
    //     "album_name": "Cars",
    //     "album_usr": 1,
    //     "created_on": "2022-09-28 04:24:53",
    //     "updated_on": "2022-09-28 04:24:53",
    //     "status": "active",
    //     "albumLength": 0
    // },
    // {
    //     "id": 14,
    //     "album_name": "Pasta",
    //     "album_usr": 1,
    //     "created_on": "2022-09-28 05:44:08",
    //     "updated_on": "2022-10-02 05:59:06",
    //     "status": "active",
    //     "albumLength": 0
    // },
    // {
    //     "id": 15,
    //     "album_name": "Desserts",
    //     "album_usr": 1,
    //     "created_on": "2022-09-29 07:19:30",
    //     "updated_on": "2022-10-02 05:53:03",
    //     "status": "active",
    //     "albumLength": 0
    // },
    // {
    //     "id": 16,
    //     "album_name": "Extra",
    //     "album_usr": 1,
    //     "created_on": "2022-10-02 17:52:08",
    //     "updated_on": "2022-10-02 17:52:08",
    //     "status": "active",
    //     "albumLength": 0
    // }
];

// const albums = null;

export default albums;